// extracted by mini-css-extract-plugin
export default {"loader":"LoadingSpinner_loader__3kIyF","line":"LoadingSpinner_line__wup-G","expand":"LoadingSpinner_expand__xb57q"};